import { useQuery } from '@tanstack/react-query';
import { CACHE_TIMES } from '@/lib/queryClient';
import type { ReviewsResponse, GoogleReview, ReviewsSummary } from '@/types/review.types';

// Real Google reviews (fallback when API is unavailable)
const FALLBACK_REVIEWS: GoogleReview[] = [
  {
    author_name: 'adam power',
    author_photo_url: null,
    rating: 5,
    text: "Incredible experience. We had great recommendations from friends so decided to use this company. Professional and makes you feel at ease from the get go. Antony collected us from our hotel for a sunset fly and we had two brilliant pilots who looked like they had years of experience! Would 100% recommend this group - it is worth paying a bit more to ensure you're getting the best service and safety.",
    relative_time_description: 'an hour ago'
  },
  {
    author_name: 'Laos light air sports channel',
    author_photo_url: null,
    rating: 5,
    text: "Super team qui organise toute vos activités au alentours de Vangvieng. Nous avons pris avec eux le paramoteur, la journee avec le tuk tuk privé et pour finir la croisière sur le lac. C'était parfait ! Une équipe accueillante et toujours disponible avec une très bonne communication. Je recommande vivement !",
    relative_time_description: 'a day ago'
  },
  {
    author_name: 'Camille Vallez',
    author_photo_url: null,
    rating: 5,
    text: "Terra Lao Adventure propose de superbes activités à prix raisonnable. Avec mon mari, nous avons testé le paramoteur et la croisière sur le lac et c'était incroyable ! Julien et Anthony sont très professionnels et sympathiques. Sans eux, notre séjour à Vang Vieng n'aurait pas été le même. Merci encore !",
    relative_time_description: '2 days ago'
  },
  {
    author_name: 'Julien M',
    author_photo_url: null,
    rating: 5,
    text: "J'ai fait le paramotor tandem flight avec Terra Lao Adventure et c'était inoubliable ! Le vol au-dessus des montagnes karstiques et de la rivière Nam Song offre des vues à couper le souffle. Les pilotes sont professionnels et rassurants, et l'équipement est sûr et moderne. La réservation a été rapide et facile, et l'équipe était très sympathique. Une expérience unique à Vang Vieng que je recommande vivement !",
    relative_time_description: '3 days ago'
  }
];

const FALLBACK_SUMMARY: ReviewsSummary = {
  average_rating: 5.0,
  total_reviews: 21
};

async function fetchReviews(): Promise<ReviewsResponse> {
  try {
    const response = await fetch('/api/reviews');

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error('Failed to fetch reviews:', error);
    // Return fallback on error
    return {
      success: true,
      reviews: FALLBACK_REVIEWS,
      summary: FALLBACK_SUMMARY,
      source: 'fallback'
    };
  }
}

export function useGoogleReviews() {
  return useQuery({
    queryKey: ['google-reviews'],
    queryFn: fetchReviews,
    ...CACHE_TIMES.SEMI_STATIC, // 15 min stale, 30 min gc
    // Always return something - fallback if error
    placeholderData: {
      success: true,
      reviews: FALLBACK_REVIEWS,
      summary: FALLBACK_SUMMARY,
      source: 'fallback' as const
    },
    retry: 2,
    retryDelay: 1000
  });
}

// Helper to get country emoji from author name (simple heuristic)
export function getCountryEmoji(_authorName: string): string {
  // For now, return a generic globe - could be enhanced with locale detection
  return '🌍';
}
